/** @flow */

import type { SystemAccessState } from "./types";

export const initialState: SystemAccessState = {
  requestsInProgress: 0,
  generalSettings: null,
  modals: {
    showAddIpRestrictionModal: false,
    showLogoModal: false,
    showPasswordResetModal: false,
    showLogOutLockModal: false,
    showClientLogoModal: false,
    showBulkRegistrationEmailsModal: false,
    showStandardRegistrationEmailsModal: false,
    showBulkRegistrationEmailsExportModal: false,
    showEmployeeRegistrationEmailsModal: false,
  },
  bulkRegistrationEmailTargets: 0,
  employeeRegistrationEmailTargets: 0,
  registrationEmails: null,
  schema: null,
  logoUrl: null,
  emails: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
};

export default initialState;
